import { PreInvoicingAlertModel } from './pre-invoicing-alert.models';
export class LoadPreInvoicingModel {
    preInvoicingStateId: number = 0;
    alerts:  Array<PreInvoicingAlertModel> = new Array<PreInvoicingAlertModel>();
}